<template>
    <div class="imprint-locations-row">
        <div
            v-for="loc in locations"
            :key="loc.code"
            class="imprint-loc-box"
        >
            <div class="imprint-loc-label">{{ loc.code }}</div>
            <a
                href="javascript:void(0)"
                class="imprint-loc-thumb-wrap"
                @click.prevent="$emit('open-modal', loc.code)"
            >
                <img
                    v-if="loc.thumbnailUrl"
                    :src="loc.thumbnailUrl"
                    class="imprint-loc-thumb"
                    alt=""
                />
                <div v-else class="imprint-loc-thumb imprint-loc-placeholder">
                    <span class="imprint-loc-placeholder-icon">◆</span>
                </div>
            </a>
            <div class="imprint-loc-meta">
                <div class="imprint-loc-type">{{ loc.type || "—" }}</div>
                <div class="imprint-loc-swatches">
                    <span
                        v-for="(c, i) in (loc.colors || []).slice(0, 4)"
                        :key="i"
                        class="imprint-swatch"
                        :style="
                            c && c.hex
                                ? 'background-color:' + (c.hex || c) + ';'
                                : ''
                        "
                    ></span>
                    <span
                        v-if="loc.colors && loc.colors.length > 4"
                        class="imprint-loc-more"
                    >
                        +{{ loc.colors.length - 4 }}
                    </span>
                </div>
            </div>
        </div>
        <button
            v-if="locations && locations.length > 0 && modalTarget"
            class="preview-artworks-btn"
            data-toggle="modal"
            :data-target="modalTarget"
        >
            Preview Artworks
        </button>
    </div>
</template>

<script>
export default {
    name: "ImprintLocationsRow",
    props: {
        locations: {
            type: Array,
            default: () => []
        },
        modalTarget: {
            type: String,
            default: ""
        }
    }
};
</script>

<style scoped>
.imprint-locations-row {
    display: flex;
    flex-wrap: nowrap;
    gap: 8px;
    align-items: stretch;
}

.imprint-loc-box {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    min-width: 100px;
    max-width: 170px;
    flex: 1 1 100px;
    min-height: 52px;
    height: 52px;
    border: 1px solid #BEBEBE4D;
    border-radius: 6px;
    padding: 4px;
    background: #fff;
    position: relative;
}

.imprint-loc-label {
    font-weight: 700;
    color: #1D6CB5;
    font-size: 13px;
    flex-shrink: 0;
    min-width: 14px;
    position: absolute;
    top: 0;
    left: 4px;
}

.imprint-loc-thumb-wrap {
    display: block;
    flex-shrink: 0;
    text-decoration: none;
    color: inherit;
    cursor: pointer;
    margin-left: 8px;
}

.imprint-loc-thumb {
    width: 32px;
    height: 32px;
    object-fit: contain;
    display: block;
}

.imprint-loc-placeholder {
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #eee;
    border-radius: 4px;
    background: #f9f9f9;
}

.imprint-loc-placeholder-icon {
    font-size: 16px;
    color: #ccc;
}

.imprint-loc-meta {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 2px;
    min-width: 0;
}

.imprint-loc-type {
    font-size: 10px;
    font-weight: 600;
    color: #000000;
    line-height: 10px;
}

.imprint-loc-swatches {
    display: flex;
    align-items: center;
    gap: 3px;
}

.imprint-swatch {
    width: 12px;
    height: 12px;
    border-radius: 2px;
    border: 1px solid #ddd;
    display: inline-block;
    flex-shrink: 0;
}

.imprint-swatch-empty {
    background: #fff;
}

.imprint-loc-more {
    margin-left: 4px;
    font-size: 11px;
    font-weight: 600;
    color: #1D6CB5;
}

.preview-artworks-btn {
    flex-shrink: 0;
    align-self: center;
    height: 36px;
    padding: 0 10px;
    border: 1px solid #E87722;
    border-radius: 5px;
    background: #fff;
    color: #E87722;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    white-space: nowrap;
    transition: background 0.15s, color 0.15s;
    line-height: 1;
}

.preview-artworks-btn:hover {
    background: #E87722;
    color: #fff;
}
</style>

